export const play = {
  play: {
    shape:
      '<path d="M1.36 1.047 12.952 8.5 1.36 15.953V1.047Z" fill="#fff" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    viewBox: [0, 0, 14, 17],
  },
};
